<template>
    <v-col class="px-4">
        <v-row no-gutters class="align-center">
            <v-avatar left
              color="primary lighten-5"
              height="55"
              width="55"
              class="mr-2"
              v-if="selectedThread.from_name"
            >
                <v-img
                    v-if="selectedThread.brand && selectedThread.brand.code != 'other'"
                    alt="sender avatar image"
                    :src="getBrandIconPath(selectedThread.brand.name)"
                ></v-img>
                <v-icon color="#00000066" v-else>mdi-account-outline</v-icon>
            </v-avatar>
            <v-col class="flex-grow-1 pl-2 pt-lg-5 pt-3">
                <div class="d-block d-lg-flex justify-space-between mr-5">
                    <div v-if="selectedThread.from_name">
                        <h3 class="d-inline-block text-truncate ellipsis"> {{ selectedThread.subject}} </h3>
                        <p> From: {{ selectedThread.from_name }} </p>
                    </div>
                    <div>
                        <v-btn
                          class="mt-8 mt-md-0"
                          color="primary"
                          :top="$vuetify.breakpoint.smAndDown"
                          right
                          absolute
                          fab
                          dark small
                          @click="$emit('close')"
                        >
                            <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
    export default {
        props: {
            selectedThread: Object,
        },
        computed: {
            userKaoshiEmail() {
                return this.$store.state.user.kaoshi_email;
            },
        }
    }
</script>

<style scoped>
.ellipsis {
    max-width: 245px;
}

@media screen and (min-width: 767px) {
    .ellipsis {
        max-width: 450px;
    }
}
</style>